import IPatient, { TypePatient } from '@/interfaces/patient';
import { toUpperCase } from '@/helpers/toUpperCase';

export default class PatientModel {
  public id: string;
  public text: string;
  public nome: string;
  public tipo: any;
  public nascimento: string;
  public idade: string;
  public idadeAMD: string;
  public idadeAMDPrescr: string;
  public peso: Number;
  public pesoCalorico: Number;
  public altura: Number;
  public imc: any;
  public sexo: string;
  public registro: string;
  public same: string;
  public leito: string;
  public termo: string;
  public convenio: string;
  public clientes: any[];
  public unidades: any[];
  public enderecos: any[];
  public ativo: boolean;

  constructor(initialValues?: IPatient) {
    this.id = !!initialValues && initialValues.id ? initialValues.id : null;
    this.text = !!initialValues && initialValues.text ? initialValues.text : '';
    this.nome = !!initialValues && initialValues.nome ? initialValues.nome : '';
    this.tipo =
      !!initialValues && initialValues.tipo ? initialValues.tipo : null;
    this.nascimento =
      !!initialValues && initialValues.nascimento
        ? initialValues.nascimento
        : '';
    this.idade =
      !!initialValues && initialValues.idade ? initialValues.idade : '0';
    this.peso = !!initialValues && initialValues.peso ? initialValues.peso : null;
    this.pesoCalorico = !!initialValues && initialValues.pesoCalorico ? initialValues.pesoCalorico : null;
    this.imc = !!initialValues && initialValues.imc? initialValues.imc : null;
    this.sexo = !!initialValues && initialValues.sexo ? initialValues.sexo : '';
    this.idadeAMD =
      !!initialValues && initialValues.idadeAMD ? initialValues.idadeAMD : '';
    this.idadeAMDPrescr =
      !!initialValues && initialValues.idadeAMDPrescr ? initialValues.idadeAMDPrescr : '';
    this.registro =
      !!initialValues && initialValues.registro ? initialValues.registro : null;
    this.same =
      !!initialValues && initialValues.same ? initialValues.same : null;
    this.convenio =
      !!initialValues && initialValues.convenio ? initialValues.convenio : null;
    this.leito =
      !!initialValues && initialValues.leito ? initialValues.leito : null;
    this.termo =
      !!initialValues && initialValues.termo ? initialValues.termo : null;
    this.clientes =
      !!initialValues && initialValues.clientes ? initialValues.clientes : [];
    this.unidades =
      !!initialValues && initialValues.unidades ? initialValues.unidades : [];
    this.enderecos =
      !!initialValues && initialValues.enderecos ? initialValues.enderecos : [];
    this.ativo = !!initialValues ? initialValues.ativo : true;
  }

  public validate(): boolean {
    return !!this.nome && !!this.nascimento && !!this.peso && !!this.sexo;
  }

  public toJson(): IPatient {
    const unidades = this.unidades.map((item) => {
      return {
        id: item.id,
      };
    });

    return {
      id: this.id,
      nome: toUpperCase(this.nome),
      nascimento: this.nascimento,
      peso: this.peso,
      pesoCalorico: null,
      imc: null,
      sexo: toUpperCase(this.sexo),
      registro: toUpperCase(this.registro),
      same: toUpperCase(this.same),
      termo: toUpperCase(this.termo),
      unidades,
      enderecos: this.enderecos,
      ativo: this.ativo,
    };
  }
}
